module.exports = __webpack_public_path__ + "img/xinbang.2605d2f0.png";